// src/util/decodeJwt.js

export function decodeJwt(token) {
  if (!token) return null;

  try {
    // JWT format: header.payload.signature
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return null;

    // Base64 decode (atob) + parse JSON
    const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(payloadJson);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
}
